export default __webpack_public_path__ + "static/iconography-image-b-af21d86df225b3f18b42a48b0aecef83.png";